import { defaultPageAttributes } from '@dtx-company/true-common/src/constants/page'
import { useCurrentPageId } from '@dtx-company/inter-app/src/hooks/useCurrentPageId'

export const useIsPagePublished = (): boolean => {
  const pageId = useCurrentPageId()
  return pageId !== defaultPageAttributes.id
}
